import React  from 'react';

import './Authentication.css';
import {
    Redirect,
    Route,
} from "react-router-dom";
import {getToken} from "../../api/token";
import {Grid} from "@material-ui/core";

export const NonAuthorizeContainer = ({ component: Component, ...rest }) => {
    const token = getToken();

    return (
        <Grid container justifyContent={"center"}>
            <Route {...rest} render={props => (
                !token
                    ? <Component {...props} />
                    : <Redirect to='/benefits' />
            )} />
        </Grid>
    );
};
